// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2TxcC","question":"Question_question__3gd6E","description":"Question_description__1-WM3"};